// 前后端共用展示排序，独立于 ruleSets 的实际匹配顺序。
function normalizeDisplayOrder(order, names) {
  const allowed = new Set(names);
  return Array.isArray(order)
    ? [...new Set(order.filter(name => typeof name === 'string' && allowed.has(name)))]
    : [];
}

function sortForDisplay(items, order, getName = item => item) {
  const ranks = new Map((Array.isArray(order) ? order : []).map((name, index) => [name, index]));
  return items.slice().sort((a, b) => {
    const left = getName(a);
    const right = getName(b);
    const leftRank = ranks.has(left) ? ranks.get(left) : Infinity;
    const rightRank = ranks.has(right) ? ranks.get(right) : Infinity;
    if (leftRank !== rightRank) return leftRank < rightRank ? -1 : 1;
    return left.localeCompare(right, 'en', { sensitivity: 'base' });
  });
}

function proxyGroupNames(config) {
  const items = (config.ruleSets || []).filter(item => item.enabled !== false);
  const names = ['Proxies', 'Auto - UrlTest'];
  if (items.some(item => item.target === 'reject')) names.push('AdBlock');
  items.forEach(item => {
    if ((item.target === 'proxy' || item.target === 'direct') && item.group) names.push(item.group);
  });
  if (!config.tail || !config.tail.finalTarget || config.tail.finalTarget === 'Others') names.push('Others');
  return [...new Set(names)];
}

module.exports = { normalizeDisplayOrder, sortForDisplay, proxyGroupNames };
